// Schema.org structured data generation for blog posts
export const generateBlogPostSchema = (post, backendUrl) => {
  const baseUrl = window.location.origin;
  const blogUrl = `${baseUrl}/blog/${post.slug || post.id}`;
  
  const wordCount = post.content ? post.content.split(/\s+/).length : 0;
  
  const currentDate = new Date().toISOString();
  const publishedDate = post.published_at ? new Date(post.published_at).toISOString() : post.created_at ? new Date(post.created_at).toISOString() : currentDate;
  const modifiedDate = post.updated_at ? new Date(post.updated_at).toISOString() : publishedDate;
  
  const imageUrl = post.featured_image ? `${backendUrl}${post.featured_image}` : `${baseUrl}/tooth-icon.svg`;
  
  const articleSection = post.categories && post.categories.length > 0 ? post.categories[0] : "Fogászat";
  
  const keywords = post.tags ? post.tags.join(', ') : "fogászat, fogorvos, száj- és fogápolás, FogPortál.hu";
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": blogUrl
    },
    "headline": post.title?.substring(0, 110) || post.title,
    "description": post.excerpt || post.meta_description || post.title,
    "image": imageUrl,
    "author": {
      "@type": "Person",
      "name": post.author || "FogPortál.hu Szerkesztőség",
      "url": `${baseUrl}/szerzo/${encodeURIComponent(post.author || 'fogportal-szerkesztoseg')}`
    },
    "publisher": {
      "@type": "Organization",
      "name": "FogPortál.hu",
      "logo": {
        "@type": "ImageObject",
        "url": `${baseUrl}/tooth-icon.svg`,
        "width": 512,
        "height": 512
      }
    },
    "datePublished": publishedDate,
    "dateModified": modifiedDate,
    "articleSection": articleSection,
    "wordCount": wordCount,
    "keywords": keywords,
    "inLanguage": "hu-HU",
    "url": blogUrl
  };
  
  return schema;
};

// Function to inject structured data into document head
export const injectStructuredData = (schema) => {
  const existingScript = document.querySelector('script[data-type="blog-structured-data"]');
  if (existingScript) {
    existingScript.remove();
  }
  
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-type', 'blog-structured-data');
  script.textContent = JSON.stringify(schema, null, 2);
  document.head.appendChild(script);
};
